module.exports = __webpack_public_path__ + "static/media/TP_Icon_FLSocks.00a85779.png";